import { compose } from "redux";

import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import CrmEnrichmentJobWizard from "app/pages/sales-intelligence/modules/crm-enrichment/impl/hubspot/containers/CrmEnrichmentJobWizard/CrmEnrichmentJobWizard";
import { withConnectionCheck } from "app/pages/sales-intelligence/pages/manage-integration/hocs/withConnectionCheck";
import withCrmEnrichmentProvider from "app/pages/sales-intelligence/pages/manage-integration/hocs/withCrmEnrichmentProvider";
import { withMappingsAndColumnsFetch } from "app/pages/sales-intelligence/pages/manage-integration/hocs/withMappingsAndColumnsFetch";

const HsEnrichmentJobWizardContainer = compose(
    withCrmEnrichmentProvider,
    withConnectionCheck,
    withSecondaryBarSet("SalesIntelligenceManagement"),
    withMappingsAndColumnsFetch({ refetchIfExists: true }),
)(CrmEnrichmentJobWizard);

export default HsEnrichmentJobWizardContainer;
